module.exports = __webpack_public_path__ + "media/images/services/06-4431737a1538b583fd7bea37176cdbf5.png";